module.exports = __webpack_public_path__ + "img/T2C_rc_3.e0bd8e1a.png";